import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b6dd864"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "slot-modal calendar-modal",
  id: "slot-modal"
}
const _hoisted_2 = { class: "slot-product-name" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { for: "slot-limit" }
const _hoisted_5 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_6 = {
  class: "limit-title",
  style: {"padding":"0 25px"}
}
const _hoisted_7 = { class: "slot-qty-change" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "path1" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "path2" }, null, -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "path1" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "path2" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "path3" }, null, -1))
const _hoisted_15 = [
  _hoisted_12,
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = { class: "mx-2" }
const _hoisted_17 = {
  key: 1,
  class: "limit-title"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OverlayModal = _resolveComponent("OverlayModal")!

  return (_openBlock(), _createBlock(_component_OverlayModal, {
    isOpen: _ctx.isOpen,
    "onUpdate:isOpen": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isOpen) = $event)),
    contentClass: "modal-limit"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.getProductName), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("calendar.v3.modal.limit.title")), 1),
          (_ctx.slotLimit == 'count')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("calendar.v3.modal.limit.limited")), 1),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", {
                    class: "icon-f icon-minus d-none-item",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.minusQuontity()))
                  }, _hoisted_10),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: _normalizeClass(["bookit-input slot-limit slot-limit-input form-control d-inline", { invalid: _ctx.invalid.limit }]),
                    disabled: _ctx.slotLimit != 'count',
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.slot.limit) = $event)),
                    min: "1",
                    onKeypress: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filterSlotLimitInput($event))),
                    onFocus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.slot.limit = _ctx.slot.limit == 0 ? '' : _ctx.slot.limit)),
                    required: ""
                  }, null, 42, _hoisted_11), [
                    [_vModelText, _ctx.slot.limit]
                  ]),
                  _createElementVNode("span", {
                    class: "icon-f icon-plus d-none-item",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.plusQuontity()))
                  }, _hoisted_15)
                ]),
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("calendar.v3.modal.limit.tickets")), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("calendar.v3.modal.limit.unlimited")), 1)
              ]))
        ])
      ]),
      (_ctx.slotLimit == 'count')
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "popup-bookit-button px-5",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args))),
            style: {"background":"#129456"},
            type: "button"
          }, _toDisplayString(_ctx.$t("button.save")), 1))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        class: "popup-bookit-button px-5",
        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args))),
        type: "button"
      }, _toDisplayString(_ctx.$t("button.close")), 1)
    ]),
    _: 1
  }, 8, ["isOpen"]))
}